import React from 'react';
import Routes from './Routes';
import Header from './components/header';
import styled from 'styled-components';

const Container = styled.div``;
const Main = styled.div`
  display: flex;
  height: calc(100vh - 85px);
  flex-direction: column;
  background: 'white';
`;
const PermissionDashboard = () => {
  return (
    <Container>
      <Header />
      <Main>
        <Routes />
      </Main>
    </Container>
  );
};

export default PermissionDashboard;
